module.exports = __webpack_public_path__ + "static/media/sling.86707d33.png";